import styled, { css } from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubtitleText = styled.span`
  font-weight: 500;
  margin-left: 5px;
`;

export const StepSection = styled.div<{ $isDisabled?: boolean }>`
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}
`;

export const StepTitle = styled.div`
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 24px;
`;

export const PreviewFields = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;
